export default __webpack_public_path__ + "static/media/2451.efa0e4c3.png";